<template lang="">
    <div :class="isPublicRoute() == true ? 'theme-card adjustment':'theme-card'">
        <!-- <PageHeader :class="isPublicRoute() == true ? 'adjustment':''" title="Privacy Policy"/> -->
        <PrivacyPolicyContent/>
    </div>
</template>
<script>
  import PageHeader from '@/components/Utility/PageHeader.vue';
  import PrivacyPolicyContent from '@/components/PrivacyPolicyContent.vue';
  export default{
    components:{
        PageHeader, PrivacyPolicyContent
    },
     mounted(){
       window.scrollTo({top: 0,behavior: 'smooth'});
    },
    methods:{
        isPublicRoute(){
            return this.$route.name == 'privacy-policy' ? true : false
        }
    }
}
</script>
<style scoped>
   .adjustment{
        margin-top: 3rem!important;
   }

   .theme-card{
    border-radius:20px;
    padding:2.2rem;
    background: url('../assets/images/blurs.png') fixed no-repeat center/90%, var(--intro-background);
   }

   @media(max-width: 768px){
    .theme-card{
        padding:1.2rem;
    }
   }
</style>